import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
import { AnswerVoiceRecorder } from "./AnswerVoiceRecorder";
import { cache } from "libs";

class QuestionAudioRecorder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: this.props.type,
      choice: [],
      idQuiz: this.props.idQuiz,
      recordDefVal: "",
    };
  }

  //--- ---

  componentDidMount() {
    const recordDefVal = this.isChecked(
      this.state.idQuiz,
      this.props.idQuestion
    );
    this.setState({
      recordDefVal,
    });
  }

  /** */
  //--- check if exists local value ---
  isChecked = (idQuiz, idQuestion) => {
    let getValue = cache.get(`quiz-${idQuiz}-${idQuestion}`);
    let result = "";

    if (getValue !== null) {
      let valAnswer = JSON.parse(JSON.stringify(getValue));
      setTimeout(() => {
        this.setMyState(idQuestion, valAnswer[0].label);
      }, 150);
      result = valAnswer[0].label;
    }

    return result;
  }; //isChecked

  /** */
  setMyState = (idQuestion, answer, e) => {
    let data = {
      idQuestion: idQuestion,
      label: answer,
    };

    this.setState({
      recordDefVal: answer,
    });

    this.setState((state) => {
      state.choice.pop();
      state.choice.push(data);

      //--- manage localStorage answer ---
      if (this.state.choice.length === 0) {
        cache.forget(
          `quiz-${this.state.idQuiz}-${idQuestion}`,
          this.state.choice
        );
      } else {
        cache.set(`quiz-${this.state.idQuiz}-${idQuestion}`, this.state.choice);
      }
    });
  }; //setMyState

  //--- ---

  render() {
    if (!this.props.type) return false;

    const { idQuestion, answers, idQuiz, label } = this.props;

    let itemLabel = label;

    return (
      <div>
        <div className="fix-quiz-form">
          {ReactHtmlParser(itemLabel)}
          <AnswerVoiceRecorder
            idQuestion={idQuestion}
            answers={answers}
            idQuiz={idQuiz}
            isEmptyLabel={this.props.answers[0].label === ''}
          />
        </div>
      </div>
    );
  }
}

export default QuestionAudioRecorder;
